import { delay, race, select, take } from "redux-saga/effects";
import { GET_USER_AND_TENANT_FAILURE, GET_USER_AND_TENANT_SUCCESS, USER_LOGIN_FAILURE, USER_LOGIN_SUCCESS, USER_LOGOUT_SUCCESS } from "./actions";

const getTenant = (state) => state.userLogin.tenant;
const getUser = (state) => state.userLogin.user;
const getUserTenantResult = (state) => state.userLogin.getUserTenantResult;

// How long a request made while the app is still signing in waits for the session.
export const SESSION_WAIT_MS = 30000;

// The signed-in tenant and user. A request made on page load can run before the session has been
// loaded (the header asks for business areas while the tenant is still being fetched): it waits for
// the session instead of failing, and fails with NO_SESSION if none arrives (at once when loading it
// has already failed).
export function* selectSession() {
    let tenant = yield select(getTenant);
    let user = yield select(getUser);
    const userTenantResult = yield select(getUserTenantResult);
    if ((!tenant || !user) && userTenantResult && userTenantResult.success === false) {
        throw noSession();
    }
    const deadline = Date.now() + SESSION_WAIT_MS;
    while (!tenant || !user) {
        const remaining = deadline - Date.now();
        const { signedOut, timedOut } = yield race({
            loaded: take([USER_LOGIN_SUCCESS, GET_USER_AND_TENANT_SUCCESS]),
            signedOut: take([GET_USER_AND_TENANT_FAILURE, USER_LOGIN_FAILURE, USER_LOGOUT_SUCCESS]),
            timedOut: delay(Math.max(remaining, 0)),
        });
        tenant = yield select(getTenant);
        user = yield select(getUser);
        if ((signedOut || timedOut) && (!tenant || !user)) {
            throw noSession();
        }
    }
    return { tenant, user };
}

function noSession() {
    return Object.assign(new Error("The session is not available."), { code: "NO_SESSION" });
}
